import { render, staticRenderFns } from "./ShoppingListDiscounts.vue?vue&type=template&id=08e6d5d0&"
import script from "./ShoppingListDiscounts.vue?vue&type=script&lang=js&"
export * from "./ShoppingListDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports